import React from 'react';
import { Stack, Text } from '@moda/om';

import './ApplePaymentMethodPreview.scss';

export const ApplePaymentMethodPreview: React.FC = ({ children }) => (
  <Stack space={0} className="ApplePaymentMethodPreview">
    <Stack space={1} direction="horizontal" alignItems="center">
      <img className="ApplePaymentMethodPreview__logo" alt="Apple Payments" src="/apple_pay.svg" />
      <Text treatment="eyebrow">Payment Method</Text>
    </Stack>
    <Stack space={0} direction="horizontal" justifyContent="space-between">
      <Text>Your selected ApplePay Payment Method</Text>
      {children}
    </Stack>
  </Stack>
);
